'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationFormContainer = exports.mapDispatchToProps = exports.LocationForm = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _decorator = require('helpers/decorator');

var _multitrack = require('helpers/multitrack');

var _LocationInputField = require('components/FormFields/LocationInputField');

var _LocationFormValidator = require('./LocationFormValidator');

var _location = require('./location.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  location: {
    id: 'location-modal.location',
    defaultMessage: 'City name'
  }
});

var LocationForm = exports.LocationForm = function (_Component) {
  (0, _inherits3.default)(LocationForm, _Component);

  function LocationForm() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, LocationForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = LocationForm.__proto__ || (0, _getPrototypeOf2.default)(LocationForm)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleFormSubmit = function (_ref2) {
      var location = _ref2.location;
      var _this$props = _this.props,
          onLocationRequest = _this$props.onLocationRequest,
          onFormSubmit = _this$props.onFormSubmit;

      onLocationRequest(location);
      if (onFormSubmit) {
        onFormSubmit(location);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(LocationForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _multitrack.ga)('Geo_Detection_Modal', 'viewed_modal', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;


      return _react2.default.createElement(
        'div',
        { className: 'location-modal--location-form' },
        _react2.default.createElement(
          'h2',
          { className: 'location-modal__title' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'location-modal.location-header',
            defaultMessage: 'Where do you work out?'
          })
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit(this.handleFormSubmit), action: '_self' },
          _react2.default.createElement(
            'div',
            { className: 'grid' },
            _react2.default.createElement(
              'div',
              { className: 'grid__item 1/1' },
              _react2.default.createElement(
                _reactIntl.FormattedMessage,
                messages.location,
                function (placeholder) {
                  return _react2.default.createElement(_reduxForm.Field, {
                    component: _LocationInputField.LocationInputField,
                    format: null,
                    name: 'location',
                    inputAttributes: { placeholder: placeholder }
                  });
                }
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'grid__item 1/1' },
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'bt bt--primary bt--width-full' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'location-modal.submit',
                  defaultMessage: 'Submit'
                })
              )
            )
          )
        )
      );
    }
  }]);
  return LocationForm;
}(_react.Component);

LocationForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired,
  onFormSubmit: _propTypes2.default.func,
  onLocationRequest: _propTypes2.default.func.isRequired
};

var formConfig = {
  form: 'locateUser',
  validate: _LocationFormValidator.LocationFormValidator
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onLocationRequest: _location.updateLocation
};

var LocationFormContainer = exports.LocationFormContainer = (0, _decorator.decorateWith)((0, _reduxForm.reduxForm)(formConfig), (0, _decorator.withName)('LocationForm'), (0, _reactRedux.connect)(null, mapDispatchToProps))(LocationForm);